import clsx from 'clsx';
import { FC, MouseEvent, ReactNode } from 'react';

import ButtonBase from '../../button/button-base';
import Typography from '../../typography';

type Props = {
  titleIcon?: string;
  titleIconFilled?: boolean;
  className?: string;
  title?: ReactNode;
  handleOnClose?: (e: MouseEvent<HTMLButtonElement>) => void;
  steps?: number;
  step?: number;
};

/**
 * Title bar of the modal.
 * Includes the title icon, title, and handle on close button.
 */
const TitleBar: FC<Props> = ({
  className = '',
  handleOnClose = undefined,
  step = undefined,
  steps = undefined,
  title = undefined,
  titleIcon = undefined,
  titleIconFilled = false,
}) => (
  <div
    className={clsx(
      'relative flex items-center justify-between gap-x-4',
      className
    )}
  >
    <div className="flex items-center gap-x-2">
      {titleIcon && (
        <span
          className={clsx(
            titleIconFilled ? 'material-icons' : 'material-icons-outlined'
          )}
        >
          {titleIcon}
        </span>
      )}

      {title && typeof title === 'string' && (
        <>
          <Typography
            className="max-w-[464px] truncate whitespace-nowrap text-gray-100"
            variant="h4"
          >
            {title}
          </Typography>
          {step && steps && (
            <Typography className="text-gray-40">
              <span className="text-gray-10">•</span> {step} of {steps}
            </Typography>
          )}
        </>
      )}

      {title && typeof title !== 'string' && title}
    </div>

    {!!handleOnClose && (
      <ButtonBase
        isCenterIconLg
        className="absolute right-0 top-0 h-[24px] w-[24px] !p-0 text-gray-100"
        variant="ghost"
        onClick={handleOnClose}
      >
        <span className="material-icons-outlined text-[14px]">close</span>
      </ButtonBase>
    )}
  </div>
);

export default TitleBar;
